import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { img1, img2 } from "../../assets/img/imgIndex";
import PageHeader from "../../components/PageHeader/PageHeader";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const DeliveryPartnerOrderView = () => {
  const location = useLocation();
  const { id, partnerId, tab, page, data: routeData } = location.state ?? {};
  const navigate = useNavigate();

  const [form, setForm] = useState([
    {
      id: 1,
      name: "Pickup Proof",
      key: "pickup_proof",
      value: img1,
      type: "img",
    },
    {
      id: 2,
      name: "Delivery Proof",
      key: "delivery_proof",
      value: img2,
      type: "img",
    },
    { id: 3, name: "Food Amount", key: "food_amount", value: "", type: "input" },
    { id: 4, name: "Tax Amount", key: "tax_amount", value: "", type: "input" },
    {
      id: 5,
      name: "Total Delivery Amount",
      key: "total_delivery_amount",
      value: "",
      type: "input",
    },
    {
      id: 6,
      name: "Delivery Partner Amount",
      key: "delivery_partner_amount",
      value: "",
      type: "input",
    },
    {
      id: 7,
      name: "Delivery Partner Admin Amount",
      key: "delivery_partner_admin_amount",
      value: "",
      type: "input",
    },
  ]);

  const mapOrderData = (d) => {
    if (!d) return;
    setForm((prev) =>
      prev.map((i) => {
        const fieldValue = d?.[i.key];
        if (i.type === "img") {
          return {
            ...i,
            value: fieldValue || i.value || "",
          };
        }
        return {
          ...i,
          value:
            fieldValue === 0 || fieldValue
              ? String(fieldValue)
              : i.value || "",
        };
      }),
    );
  };

  const fetchData = async (orderId) => {
    try {
      const url = partnerId
        ? `${URLS.DELIVERYPARTNER}${partnerId}/orders/${orderId}/`
        : `${URLS.DELIVERYPARTNER}orders/${orderId}/`;
      const res = await get(url);
      if (res?.status === "success") {
        mapOrderData(res?.data);
      }
    } catch (error) {
      console.error("Error fetching delivery partner order:", error);
    }
  };

  useEffect(() => {
    if (routeData) {
      mapOrderData(routeData);
    }
    if (id) {
      fetchData(id);
    }
  }, []);

  return (
    <div>
      <PageHeader
        title="Delivery Partner Order"
        showBackButton={true}
        onBackClick={() =>
          navigate("/delivery-partner-view", {
            state: { page: page || 1, tab: tab || 1, id: partnerId },
          })
        }
      />
      <div className="form-grid">
        {form.map((i) => {
          if (i.type === "input") {
            return (
              <div className="form-item" key={i.id}>
                <div className="form-group">
                  <label>{i.name}</label>
                  <input type="text" value={i.value || ""} readOnly />
                </div>
              </div>
            );
          }

          if (i.type === "img") {
            return (
              <div className="form-item" key={i.id}>
                <div className="form-group">
                  <label>{i.name}</label>
                  <div className="img-row">
                    {i.value ? (
                      <img
                        src={i.value}
                        className="food-img"
                        alt={i.name}
                        style={{
                          width: 180,
                          height: 180,
                          cursor: "pointer",
                        }}
                        onClick={() => window.open(i.value, "_blank")}
                      />
                    ) : (
                      <span>-</span>
                    )}
                  </div>
                </div>
              </div>
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};

export default DeliveryPartnerOrderView;
